import { render, staticRenderFns } from "./EmploymentEmployerEdit.vue?vue&type=template&id=2a19766f&scoped=true&"
import script from "./EmploymentEmployerEdit.vue?vue&type=script&lang=js&"
export * from "./EmploymentEmployerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a19766f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a19766f')) {
      api.createRecord('2a19766f', component.options)
    } else {
      api.reload('2a19766f', component.options)
    }
    module.hot.accept("./EmploymentEmployerEdit.vue?vue&type=template&id=2a19766f&scoped=true&", function () {
      api.rerender('2a19766f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Employer/EmploymentEmployerEdit.vue"
export default component.exports